import { Pathname } from "history";
import { match, matchPath } from "react-router";

import { Route } from "@/mk2/containers/Application/Application";
import { getLogger } from "@/mk2/logger";
import { routes } from "@/mk2/router";
import { parsePathBackport } from "@/mk2/services/historyBackports";
import { WIKI_CATEGORIES } from "@/mk/autogenerated/wikiCategories";
import { BASE_URL } from "@/mk/settings";

const logger = getLogger("helpers/router");

// Reviews center category (id 13): "recenzie" (SK) / "recenze" (CZ).
const REVIEWS_PATH_PREFIX = `/${WIKI_CATEGORIES.filter((wc) => wc.id === 13)[0].slug}/`;

export function isReviewsPath(to: string) {
    if (!to) {
        return false;
    }
    if (to.startsWith(BASE_URL)) {
        to = to.substring(BASE_URL.length);
    }
    return parsePathBackport(to).pathname.startsWith(REVIEWS_PATH_PREFIX);
}

export function computeRouteMatch(pathname: Pathname, route: Route): match<any> {
    if (!route.path) {
        // Ignore all catch routes
        return null;
    }

    return matchPath(pathname, {
        path: route.path,
        exact: true,
        // prepare for react-router v6 upgrade
        // that is case sensitive
        sensitive: true,
    });
}

export function isPWARoute(to: string) {
    if (!to) {
        logger.warn("isPWARoute: called with empty to", { to });
        return false;
    }

    // Remove BASE_URL from absolute links
    if (to.startsWith(BASE_URL)) {
        to = to.substring(BASE_URL.length);
    }

    if (to.startsWith("http")) {
        // Different hostname - always use <a>
        return false;
    }

    const parsed = parsePathBackport(to);

    // Check if we have a route for this URL
    for (const route of routes) {
        const match = computeRouteMatch(parsed.pathname, route);
        if (match) {
            return true;
        }
    }

    // no route matched
    return false;
}
